export default __webpack_public_path__ + "static/media/pictoVideo.1b9623f3.svg";